// Enums
export const NAV_LOCATIONS = {
  PRIMARY: 'Primary',
  BUNDLES: 'Bundles',
  ACCOUNT: 'Account',
  FOOTER: 'Footer',
};
export const NAV_SECTIONS = {
  PRIMARY: {
    TOP_BAR: {
      LOGO: 'Logo',
      CTA: 'CTA',
      MAIN: 'Main',
      ICONS: 'Icons',
    },
    LATEST: {
      FEATURED_PRODUCTS: 'Featured Products',
      NEWSLETTER_FORM: 'Newsletter Form',
    },
    FLAVORS: {
      FEATURED_LINKS: 'Featured Links',
      CATEGORIES: 'Categories',
      PROMO_CARDS: 'Promo Cards',
    },
    BOTTLES: {
      FEATURED_LINKS: 'Featured Links',
      CATEGORIES: 'Categories',
      PROMO_CARDS: 'Promo Cards',
    },
    EXTRAS: {
      FEATURED_LINKS: 'Featured Links',
      CATEGORIES: 'Categories',
      PROMO_CARDS: 'Promo Cards',
    },
    MOBILE: {
      MENU_TOGGLE: 'Mobile Menu Toggle',
      MENU_BACK: 'Mobile Menu Back',
      CTA: 'Mobile CTA',
      MAIN: 'Mobile Main',
      JUMP_TO: 'Mobile Jump To',
      BOTTOM_LINKS: 'Mobile Bottom Links',
    }
  },
};
export const NAV_ELEMENT_TYPES = {
  BUTTON: 'Button',
  PILL: 'Pill',
  TEXT: 'Text',
  ICON: 'Icon',
  IMAGE: 'Image',
  BACKDROP: 'Backdrop',
};
export const NAV_ACTIONS = {
  LINK: 'Link',
  SCROLL_TO: 'Scroll To',
  OPEN_SUBMENU: 'Open Submenu',
  CLOSE_SUBMENU: 'Close Submenu',
  SUBMIT: 'Submit',
};
const VALID_NAV_LOCATIONS = _flattenObjectValuesMap(NAV_LOCATIONS);
const VALID_NAV_SECTIONS = _flattenObjectValuesMap(NAV_SECTIONS);
const VALID_NAV_ELEMENT_TYPES = _flattenObjectValuesMap(NAV_ELEMENT_TYPES);
const VALID_NAV_ACTIONS = _flattenObjectValuesMap(NAV_ACTIONS);

let currentNavJourneyByDepth = [];

export function logNavInteraction({ location, depth, section, order, elementType, text, action }) {
  const NAV_INTERACTION_EVENT_NAME = 'UAT: Nav Interaction'; // TODO: Remove UAT: prefix once Data team approves of sample data
  const validationErrors = [];
  const interactionProperties = {
    location,
    depth,
    section,
    order,
    elementType,
    text,
    action,
  };

  // console.log('[log-nav-interaction] logNavInteraction', interactionProperties);
  // console.log('[log-nav-interaction] currentNavJourneyByDepth', currentNavJourneyByDepth);

  try {
    __validateLocation();
    __validateDepth();
    __validateSection();
    __validateOrder();
    __validateElementType();
    __validateText();
    __validateAction();

    if (validationErrors.length) {
      console.error('[log-nav-interaction] validationErrors', validationErrors);
    } else if (window.amplitude) {
      currentNavJourneyByDepth = currentNavJourneyByDepth.slice(0, interactionProperties.depth);
      currentNavJourneyByDepth.push(interactionProperties);

      const eventBody = {
        ...interactionProperties,
        parents: currentNavJourneyByDepth.slice(0, interactionProperties.depth),
        currentPage: {
          domain: window.location.host,
          path: window.location.pathname,
        }
      };

      // console.log('[log-nav-interaction] LOGGING', NAV_INTERACTION_EVENT_NAME, JSON.stringify(eventBody));
      window.amplitude.getInstance().logEvent(NAV_INTERACTION_EVENT_NAME, eventBody);
    }
  } catch(error) { // Failure to log shouldn't break anything else. Catch and dump to console.
    console.error('[log-nav-interaction] ERROR', error);
  }
  
  function __validateLocation() {
    if (interactionProperties.location === null || interactionProperties.location === undefined) {
      validationErrors.push({
        property: 'location',
        message: `location is required`,
      });
    } else if (!VALID_NAV_LOCATIONS[interactionProperties.location]) {
      validationErrors.push({
        property: 'location',
        message: `Unknown location`,
      });
    }  
  }

  function __validateDepth() {
    if (interactionProperties.depth === null || interactionProperties.depth === undefined) {
      validationErrors.push({
        property: 'depth',
        message: `depth is required`,
      });
    } else if (!(Number.isInteger(interactionProperties.depth) && interactionProperties.depth >= 0)) {
      validationErrors.push({
        property: 'depth',
        message: `depth must be an integer >= 0`,
      });
    }
  }
  
  function __validateSection() {
    if (interactionProperties.section === null || interactionProperties.section === undefined) {
      validationErrors.push({
        property: 'section',
        message: `section is required`,
      });
    } else if (!VALID_NAV_SECTIONS[interactionProperties.section]) {
      validationErrors.push({
        property: 'section',
        message: `Unknown section`,
      });
    } 
  }
  
  function __validateOrder() {
    if (interactionProperties.order === null || interactionProperties.order === undefined) {
      validationErrors.push({
        property: 'order',
        message: `order is required`,
      });
    } else if (!(Number.isInteger(interactionProperties.order) && interactionProperties.order >= 1)) {
      validationErrors.push({
        property: 'order',
        message: `order must be an integer >= 1`,
      });
    } 
  }

  function __validateElementType() {
    if (interactionProperties.elementType === null || interactionProperties.elementType === undefined) {
      validationErrors.push({
        property: 'elementType',
        message: `elementType is required`,
      });
    } else if (!VALID_NAV_ELEMENT_TYPES[interactionProperties.elementType]) {
      validationErrors.push({
        property: 'elementType',
        message: `Unknown elementType`,
      });
    } 
  }
  
  function __validateText() {
    if (interactionProperties.text === null || interactionProperties.text === undefined) {
      validationErrors.push({
        property: 'text',
        message: `text is required`,
      });
    } 
  }
  
  function __validateAction() {
    if (interactionProperties.action === null || interactionProperties.action === undefined) {
      validationErrors.push({
        property: 'action',
        message: `action is required`,
      });
    } else if (!VALID_NAV_ACTIONS[interactionProperties.action]) {
      validationErrors.push({
        property: 'action',
        message: `Unknown action`,
      });
    } 
  }
}

function _flattenObjectValuesMap(originalObject) {
  const values = {};

  __deepFlatten(originalObject);

  return values;

  function __deepFlatten(object) {
    Object.values(object).forEach((value) => {
      if (typeof value === 'object') {
        __deepFlatten(value);   
      } else {
        values[value] = value;  
      }
    });
  }
}
